export default __webpack_public_path__ + "static/media/logo5.f71bcd60.jpg";